export { default } from './ProductSection';



// WEBPACK FOOTER //
// ./src/components/ProductSection/index.js